import * as React from "react";
import { Grid } from "@mui/material";
// import PedidoTiendaForm from "../components/PedidoTiendaForm.js";
import { styles } from "../theme/styles";
// import VerPedido from "../components/VerPedido";
import VerPedido from "../components/VerPedido";
function VerPedidoTienda() {
  return (
    <Grid style={styles.content3} container>
      <VerPedido />
    </Grid>
  );
}

export default VerPedidoTienda;
